import { Injectable } from '@angular/core';
import { createAction, props } from '@ngrx/store';

@Injectable()
export class JobActions {
    static sendTestMessage = createAction('[Template:Send:Test] Send Test Message',
        props<{ context: any, userId: any, userName: any, contentType: any, templateFileRef: any,
                templateId: any, destinator: any, mediaType: any, deviceId: any }>());

    static sendTestMessageSuccess =
        createAction('[Template:Send:Test]  Send Test Message Success');

    static sendTestMessageFailed =
        createAction('[Template:Send:Test]  Send Test Message Failed', props<{ error: any}>());
}
